import {
  init_preact_module,
  l
} from "./chunk--chunk-WOOXM6XY.vbt.js";

// node_modules/preact/jsx-runtime/dist/jsxRuntime.module.js
init_preact_module();
init_preact_module();
var f = 0;
var i = Array.isArray;
function u(e, t, n, o, i2, u2) {
  t || (t = {});
  var a, c, p = t;
  if ("ref" in p)
    for (c in p = {}, t)
      "ref" == c ? a = t[c] : p[c] = t[c];
  var l2 = { type: e, props: p, key: n, ref: a, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: --f, __i: -1, __u: 0, __source: i2, __self: u2 };
  if ("function" == typeof e && (a = e.defaultProps))
    for (c in a)
      void 0 === p[c] && (p[c] = a[c]);
  return l.vnode && l.vnode(l2), l2;
}

export {
  u
};
